import { useMemo } from "react";
import { IComponentType, ITrackingTypes } from "../component-data-structure";
const getSceneScreenContentId = (sceneId, componentsById) => {
    const activeSceneChildren = componentsById[sceneId]?.children || [];
    return activeSceneChildren.filter(id => componentsById[id].type === IComponentType.ScreenContent)[0];
};
export const getFaceLandmarkIdsBySceneId = (sceneId, componentsById) => {
    const activeSceneChildren = componentsById[sceneId]?.children || [];
    return activeSceneChildren.filter(id => componentsById[id].type === IComponentType.FaceLandmarkGroup);
};
export const useGetScreenRelativeComponentIds = (sceneId, componentsById) => {
    return useMemo(() => {
        if (!componentsById)
            return [];
        const sceneContentId = getSceneScreenContentId(sceneId, componentsById);
        const sceneContent = componentsById[sceneContentId];
        return sceneContent.children.reduce((screenContentIds, anchorId) => {
            const child = componentsById[anchorId];
            if (!child)
                return screenContentIds;
            if (child.type === IComponentType.ScreenAnchorGroup) {
                screenContentIds.push(...child.children);
            }
            return screenContentIds;
        }, []);
    }, [componentsById, sceneId]);
};
export const useGetFaceTrackedComponentIds = (sceneId, componentsById) => {
    return useMemo(() => {
        return getFaceTrackedComponentIds(sceneId, componentsById);
    }, [componentsById, sceneId]);
};
export const getFaceTrackedComponentIds = (sceneId, componentsById) => {
    if (!componentsById)
        return [];
    if (componentsById[sceneId].trackingType !== ITrackingTypes.face)
        return [];
    const faceLandmarkIds = getFaceLandmarkIdsBySceneId(sceneId, componentsById);
    return faceLandmarkIds.reduce((acc, landmarkId) => {
        const landmarkGroup = componentsById[landmarkId];
        return [...acc, ...landmarkGroup.children];
    }, []);
};
